// frontend/src/components/quizzes/QuizSetupCard.tsx

import { useState } from 'react';

interface QuizCategory {
  id: string;
  name: string;
  icon: string;
  suggestions: string[];
}

const CATEGORIES: QuizCategory[] = [
  {
    id: 'all',
    name: 'Tüm Konular',
    icon: '🎓',
    suggestions: ['Türev & İntegral', 'Python Döngüleri & OOP', 'Fotosentez & Hücre', 'Paragrafta Anlam & Dil Bilgisi', 'İngilizce Reading & Vocab', 'Mantık Muhakeme'],
  },
  {
    id: 'math',
    name: 'Matematik & Mantık',
    icon: '📐',
    suggestions: ['Türev ve Uygulamaları', 'İntegral & Alan Hesabı', 'Trigonometri & Fonksiyonlar', 'Kesirler & Oranlar', 'Geometrik İspat & Açılar'],
  },
  {
    id: 'coding',
    name: 'Kodlama & Yazılım',
    icon: '🐍',
    suggestions: ['Veri Yapıları & Algoritmalar', 'Nesne Yönelimli Programlama (OOP)', 'Python Fonksiyonlar & Listeler', 'Döngüler & Koşullar', 'Hata Ayıklama (Debugging)'],
  },
  {
    id: 'science',
    name: 'Fen & Teknoloji',
    icon: '🧪',
    suggestions: ['Kuantum & Modern Fizik', 'Elektromanyetizma & Devreler', 'Fotosentez & Solunum', 'Genetik & DNA Replikasyonu', 'Güneş Sistemi & Gezegenler'],
  },
  {
    id: 'language',
    name: 'Türkçe & Dil',
    icon: '📚',
    suggestions: ['Paragrafta Anlatım Teknikleri', 'Cümlede Anlam & Yorum', 'Dil Bilgisi & Cümle Ögeleri', 'Yazım Kuralları & Noktalama'],
  },
  {
    id: 'english',
    name: 'İngilizce',
    icon: '🇬🇧',
    suggestions: ['Advanced Grammar & Tenses', 'Academic Reading & Vocabulary', 'Daily Conversation & Idioms', 'Sentence Completion'],
  },
  {
    id: 'puzzles',
    name: 'Zeka Oyunları',
    icon: '🧩',
    suggestions: ['Sayısal Mantık & Akıl Oyunları', 'Kriptoloji & Şifre Çözme', 'Desen & Örüntü Tamamlama'],
  },
];

interface QuizSetupCardProps {
  onStart: (topic: string) => void;
  isLoading: boolean;
}

export function QuizSetupCard({ onStart, isLoading }: QuizSetupCardProps) {
  const [topic, setTopic] = useState('');
  const [activeCategory, setActiveCategory] = useState<string>('all');

  const category = CATEGORIES.find((c) => c.id === activeCategory) || CATEGORIES[0];

  function handleSubmit(e: React.FormEvent) {
    e.preventDefault();
    if (!topic.trim()) return;
    onStart(topic.trim());
  }

  return (
    <div className="quiz-container quiz-setup">
      <h2>Yeni Quiz Oluştur 📝</h2>
      <p>Hangi derste ve konuda kendini test etmek istersin?</p>

      {/* Ders Seçim Sekmeleri */}
      <div className="quiz-category-tabs">
        {CATEGORIES.map((cat) => (
          <button
            key={cat.id}
            type="button"
            className={`quiz-category-tab ${activeCategory === cat.id ? 'active' : ''}`}
            onClick={() => setActiveCategory(cat.id)}
            disabled={isLoading}
          >
            <span>{cat.icon}</span> {cat.name}
          </button>
        ))}
      </div>

      <form onSubmit={handleSubmit} className="quiz-setup-form">
        <input
          type="text"
          placeholder="Örn: Kesirler, Fotosentez, Python Döngüler veya İngilizce..."
          value={topic}
          onChange={(e) => setTopic(e.target.value)}
          disabled={isLoading}
        />
        <button type="submit" className="lesson-btn primary" disabled={isLoading || !topic.trim()}>
          {isLoading ? '⏳ Hazırlanıyor...' : '🚀 Quiz Oluştur'}
        </button>
      </form>

      <div className="quiz-setup-suggestions">
        {category.suggestions.map((t) => (
          <button key={t} type="button" onClick={() => onStart(t)} disabled={isLoading}>
            {category.icon} {t}
          </button>
        ))}
      </div>
    </div>
  );
}
